import CertificateProps from '@/interfaces/certificates';

import { get } from './api';

class CertificateService {
  public async list(limit = 100) {
    const response = await get<{ data: CertificateProps[] }>({
      url: `/user/certificates?size=${limit}`
    });

    return response?.data;
  }
}

const certificateService = new CertificateService();
export default certificateService;
